export default __webpack_public_path__ + "static/media/instructor_collage.28ea67ca.png";